import { getBankDetailRequirements } from './getBankDetailRequirements';
import styles from './SecureYourPayments.module.css';
import { Base } from './SecureYourPaymentsForm/Base/Base';
import { SoleTrader } from './SecureYourPaymentsForm/SoleTrader/SoleTrader';
import { useUploadedDocuments } from './SecureYourPaymentsForm/useUploadedDocuments.hook';
import { useFormType } from './useFormType.hook';
import {
  useGetSellerOnboardingRequirements,
  useGetStateByStateKey,
} from '../../../api/lending/lapiHooks';
import { useStateKey } from '../../../hooks/useStateKey.hook';
import { PendingCra } from '../PendingCra/PendingCra';

export const SecureYourPayments = ({
  isLoading = false,
}: {
  isLoading?: boolean;
}) => {
  const { stateKey } = useStateKey();
  const { state: customerState } = useGetStateByStateKey();
  const {
    sellerOnboardingRequirements,
    fetchSellerOnboardingRequirements: fetchRequirements,
  } = useGetSellerOnboardingRequirements();
  const requirements = sellerOnboardingRequirements?.data;
  const formType = useFormType({ customerState: customerState! });
  const { uploadedFiles, hasUploadedFiles, getUploadedDocuments } =
    useUploadedDocuments({
      stateKey,
    });
  const resolutionMethods = getBankDetailRequirements(requirements);

  const renderFormType = () => {
    if (formType === 'SOLE_TRADER') {
      return (
        <SoleTrader
          hasUploadedFiles={hasUploadedFiles}
          fetchRequirements={fetchRequirements}
          uploadedFiles={uploadedFiles}
          getUploadedDocuments={getUploadedDocuments}
          resolutionMethods={resolutionMethods}
          isLoading={isLoading}
        />
      );
    }

    return (
      <Base
        fetchRequirements={fetchRequirements}
        uploadedFiles={uploadedFiles}
        getUploadedDocuments={getUploadedDocuments}
        resolutionMethods={resolutionMethods}
        isLoading={isLoading}
      />
    );
  };

  return (
    <div className={styles.secureYourPaymentsContainer}>
      <div data-testid="secureYourPaymentsText" className={styles.title}>
        Your <b>business bank account</b> - the one you want the funds sent to.
      </div>

      <div className={styles.secureYourPaymentsForm}>{renderFormType()}</div>

      {(resolutionMethods?.manualBankDetailsVerification?.status ===
        'pending' ||
        resolutionMethods?.documentUpload?.status === 'pending') &&
        formType === 'BASE' && <PendingCra />}
    </div>
  );
};
